import React from 'react';
import cn from 'classnames';
import './modal.styles.scss';
import { useTranslation } from 'react-i18next';
import { ModalWrapper } from './ModalWrapper';
import { ModalQuestionIcon } from '../icons';
import { Button } from '../base';

interface DialogModalProps {
	onClickFirstButton?: () => void;
	onClickSecondButton?: () => void;
	firstButtonText?: string;
	secondButtonText?: string;
	hiddenIcon?: boolean;
	alignLeft?: boolean;
	title?: string;
	text?: string;
	wrapperClass?: string;
}

export const DialogModal = ({
	onClickFirstButton,
	onClickSecondButton,
	firstButtonText,
	secondButtonText,
	title,
	text,
	alignLeft,
	wrapperClass,
	hiddenIcon,
}: DialogModalProps) => {
	const { t } = useTranslation('common');

	return (
		<ModalWrapper type="result" contentWrapperClass={wrapperClass}>
			{!hiddenIcon && <ModalQuestionIcon iconClass="modal-icon-result" />}
			<h2
				className={cn('modal-result__title', {
					'modal-result__title_left': alignLeft,
				})}
			>
				{title ?? t('modals.great')}
			</h2>
			{text && (
				<p
					className={cn('modal-result__text', {
						'modal-result__text_left': alignLeft,
					})}
				>
					{text}
				</p>
			)}
			<div className="flex-width">
				{firstButtonText && (
					<Button
						buttonText={firstButtonText}
						buttonClass="modal-result__btn"
						buttonStyle="secondary"
						onClick={onClickFirstButton}
						toLeft
					/>
				)}
				{secondButtonText && (
					<Button
						buttonText={secondButtonText}
						buttonClass="modal-result__btn"
						onClick={onClickSecondButton}
						toRight
					/>
				)}
			</div>
		</ModalWrapper>
	);
};
